class RecentSalesNotifications extends HTMLElement {
  connectedCallback() {
    this.endpoint = this.dataset.endpoint;
    this.firstDelay = (parseInt(this.dataset.firstDelay, 10) || 5) * 1000;
    this.interval = (parseInt(this.dataset.interval, 10) || 8) * 1000;
    this.displayDuration = 5500;
    this.refetchInterval = 60000;
    this.sales = [];
    this.currentIndex = 0;

    if (!this.endpoint) return;

    try {
      if (window.sessionStorage.getItem('maloby-recent-sales-dismissed') === 'true') {
        this.dismissed = true;
      }
    } catch (e) {
      /* ignore */
    }

    this.card = document.createElement('div');
    this.card.className = 'recent-sale-toast';
    this.card.innerHTML = `
      <button type="button" class="recent-sale-toast__close" aria-label="Fermer">
        <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg>
      </button>
      <span class="recent-sale-toast__image"></span>
      <span class="recent-sale-toast__body">
        <span class="recent-sale-toast__eyebrow">
          <span class="recent-sale-toast__dot" aria-hidden="true"></span>
          Vente recente
        </span>
        <span class="recent-sale-toast__text"></span>
      </span>
    `;
    this.appendChild(this.card);
    this.card.querySelector('.recent-sale-toast__close').addEventListener('click', () => {
      this.hide();
      this.dismissed = true;
      try {
        window.sessionStorage.setItem('maloby-recent-sales-dismissed', 'true');
      } catch (e) {
        /* ignore */
      }
    });

    this.fetchSales();
    setInterval(() => this.fetchSales(), this.refetchInterval);
    setTimeout(() => this.showNext(), this.firstDelay);
  }

  async fetchSales() {
    try {
      const response = await fetch(this.endpoint);
      if (!response.ok) return;
      const data = await response.json();
      if (Array.isArray(data)) this.sales = data;
    } catch (e) {
      /* endpoint unavailable, silently skip */
    }
  }

  hide() {
    this.card.classList.remove('recent-sale-toast--visible');
  }

  showNext() {
    if (this.dismissed || this.sales.length === 0) {
      setTimeout(() => this.showNext(), this.interval);
      return;
    }

    const sale = this.sales[this.currentIndex % this.sales.length];
    this.currentIndex++;

    const imageEl = this.card.querySelector('.recent-sale-toast__image');
    const textEl = this.card.querySelector('.recent-sale-toast__text');

    if (sale.image) {
      imageEl.innerHTML = `<img src="${sale.image}" alt="" width="52" height="52" loading="lazy">`;
    } else {
      imageEl.innerHTML = '';
    }
    textEl.innerHTML = `<strong>Quelqu'un &agrave; ${this.escapeHtml(sale.city)}</strong> vient d'acheter<br>${this.escapeHtml(sale.product)}`;

    this.card.classList.add('recent-sale-toast--visible');

    setTimeout(() => {
      this.hide();
      setTimeout(() => this.showNext(), this.interval);
    }, this.displayDuration);
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }
}

if (!customElements.get('recent-sales-notifications')) {
  customElements.define('recent-sales-notifications', RecentSalesNotifications);
}
